import createEnum from 'scripts/lib/create_enum';

const CompositionContentType = createEnum(
  'CHAT',
  'CONVERSATION',
  'CONVERSATION_MESSAGE',
  'CONVERSATION_NOTE',
  'CREDIT_CARD_REQUEST',
  'EMAIL',
  'EXTERNAL_FORM',
  'FB_MESSAGE',
  'PHONE_CALL',
  'PHONE_CALLBACK',
  'SMS',
  'TASK',
  'TASK_EDIT',
  'TWITTER'
);

export default CompositionContentType;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/composition/composition_content_type.js